export const CLOTHING_CATEGORY = "Ropa";
export const LOW_STOCK_THRESHOLD = 5;

export const GENDER_OPTIONS = [
  { value: "Dama", label: "Dama" },
  { value: "Caballero", label: "Caballero" },
  { value: "Unisex", label: "Unisex" },
];

export const SIZE_OPTIONS = ["XCH","CH", "M", "G", "XG", "XXG"].map((s) => ({
  value: s,
  label: s,
}));
